export const ADD_DATA = "ADD_DATA" 
export const FIND_LOCA = "FIND_LOCA"
export const INDIVIDUAL = "INDIVIDUAL"
export const ADD_CART = "ADD_CART"